/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Faq_A2Inputs */

const en_diff_faq_a2 = /** @type {(inputs: Diff_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. The comparison is recursive and detects differences at every nesting level, including arrays.`)
};

const ko_diff_faq_a2 = /** @type {(inputs: Diff_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`네. 비교는 재귀적으로 수행되며 배열을 포함한 모든 중첩 레벨에서 차이점을 감지합니다.`)
};

const ja_diff_faq_a2 = /** @type {(inputs: Diff_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。比較は再帰的に行われ、配列を含むすべてのネストレベルで差分を検出します。`)
};

/**
* | output |
* | --- |
* | "Yes. The comparison is recursive and detects differences at every nesting level, including arrays." |
*
* @param {Diff_Faq_A2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_faq_a2 = /** @type {((inputs?: Diff_Faq_A2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Faq_A2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_faq_a2(inputs)
	if (locale === "ko") return ko_diff_faq_a2(inputs)
	return ja_diff_faq_a2(inputs)
});